<template>

  <div>
    <b-overlay :show="overlay">
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end actions-wrapper">
                <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por código ou descrição..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button
                    variant="primary"
                    v-b-modal.modal-add-tipo-comunicado
                    @click="resetFormData"
                >
                  <div class="d-flex" style="gap: 5px">
                    <iconfy icon="mdi:plus"/>
                    <span class="">Tipo Comunicado</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refTipoComunicadoListTable"
            class="position-relative"
            :items="fetchTipoComunicado"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-primary"
                  title="Editar"
                  class="btn-icon mr-1"
                  @click="openEditModal(data.item)"
              >
                <feather-icon icon="EditIcon"/>
              </b-button>

              <b-button
                  variant="gradient-danger"
                  title="Deletar"
                  class="btn-icon"
                  @click="openModalDeleteCustomField(data.item)"
              >
                <feather-icon icon="TrashIcon"/>
              </b-button>
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalTipoComunicado"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalAdd
        idModal="modal-add-tipo-comunicado"
        titleModal="Adicionar Tipo Comunicado"
        labelBtnOk="Adicionar"
        v-model="dataTipoComunicado"
        @ok="create($event)"
        @cancel="resetFormData()"
    />
    <ModalAtt
        idModal="modal-att-tipo-comunicado"
        titleModal="Atualizar Tipo Comunicado"
        labelBtnOk="Atualizar"
        v-model="dataTipoComunicado"
        @ok="Updated($event)"
        @cancel="resetFormData()"
    />

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-tipo-comunicado"
        title="Deletar Tipo Comunicado"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedCustomField.tipocomunicadoid)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Tipo Comunicado?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAdd from '@/views/cadastros/comunicado/tipo-comunicado/list/ModalAdd.vue';
import ModalAtt from '@/views/cadastros/comunicado/tipo-comunicado/list/ModalAtt.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useList from './useList';

export default {
  components: {
    ModalAdd,
    ModalAtt,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        tipocomunicadoid: null,
        tipocomunicadodescricao: '',
      },
      searchInputValue: '',
    };
  },
  methods: {
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Tipo Comunicado deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataTipoComunicado = data;
      this.$bvModal.show('modal-att-tipo-comunicado');
    },
    resetFormData() {
      this.deletedCustomField = {
        tipocomunicadoid: null,
        tipocomunicadodescricao: '',

      };
      this.dataTipoComunicado = {
        tipocomunicadoid: null,
        tipocomunicadodescricao: '',
      };
      this.isDeleteModal = false;
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const customFields = ref([]);
    const dataTipoComunicado = ref({
      tipocomunicadoid: null,
      tipocomunicadodescricao: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);

    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalTipoComunicado,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refTipoComunicadoListTable,
      fetchTipoComunicado,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      create,
      Updated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,
      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      currentTab,
      dataTipoComunicado,
      typeOptionsCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalTipoComunicado,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchTipoComunicado,
      overlay,
      tableColumns,
      refTipoComunicadoListTable,
      Updated,
      create,
      removerData,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}

.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
